import React, { FC } from 'react'
import styled from 'styled-components'

const EmptyCellWrapper = styled.div`
  text-align: center;
`

export interface Props {}

export const EmptyCell: FC<Props> = ({}) => {
  return <EmptyCellWrapper>--</EmptyCellWrapper>
}
